<template>
  <div :class="treeNodeClass" role="listitem">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, mixins } from "vue-facing-decorator";
import ServicedMixin from "@/components/field-element";

@Component({
  name: "cat-tree-node",
  mixins: [ServicedMixin]
})
export default class CatTreeNode extends Vue {
  get treeNodeClass(): object {
    return {
      "cat-tree-node": true
    };
  }
}
</script>
